<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="svg-frame"
    v-html="svg"
  ></div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { useReceiptSlipPrint } from '@yonarezi/yonarezi3.slip-print'

export default {
  props: {
    baseOptions: { type: [Object, null], default: null },
    row: { type: Object, required: true },
  },
  setup(props) {
    const options = computed(() => ({
      ...(props.baseOptions || {}),
      customerName: props.row.to || '',
      receiptNote: props.row.note || '',
      date: props.row.issuedDate || new Date(),
      total: Number(props.row.amount || 0),
      receiptSlipNumber: '',
      footerItems: [],
    }))
    const { svg } = useReceiptSlipPrint(options)

    return { svg }
  },
}
</script>

<style scoped>
.svg-frame {
  background: white;
  padding: 8px;
  border-radius: 4px;
}
.svg-frame >>> svg {
  width: 100%;
  height: auto;
  display: block;
}
</style>
